import * as React from "react";

interface FileIconProps {
  color?: string;
  className?: string;
  size?: number;
}

export const FileIcon: React.FC<FileIconProps> = ({
  color = "#070606",
  className,
  size = 2,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.5 10.1667H7.5V9.16667H2.5V10.1667ZM2.5 7.5H7.5V6.5H2.5V7.5ZM1.20517 12.6667C0.868389 12.6667 0.583333 12.55 0.35 12.3167C0.116667 12.0833 0 11.7983 0 11.4615V1.20517C0 0.868389 0.116667 0.583333 0.35 0.35C0.583333 0.116667 0.868389 0 1.20517 0H6.5L10 3.5V11.4615C10 11.7983 9.88333 12.0833 9.65 12.3167C9.41667 12.55 9.13161 12.6667 8.79483 12.6667H1.20517ZM6 4H9L6 1V4Z"
        fill={color}
      />
    </svg>
  );
};
